var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-text"},[_c('p',[_vm._v(_vm._s(_vm.labelText))])])
}
var staticRenderFns = []

export { render, staticRenderFns }